import { cn } from "@newxsystems/shared";
import { SproutCommonContent } from "../../../../modules/content/components/SproutCommonContent/SproutCommonContent";
import { SproutRichText } from "../../../../modules/content/components/SproutRichText/SproutRichText";
import { SproutSection } from "../../../../modules/content/components/SproutSection/SproutSection";
import type { IStatsBlockProps } from "./StatsBlock.props";

const columns = {
  1: "grid-cols-1",
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
} as const;

export const StatsBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: IStatsBlockProps) => {
  if (!items?.length) return null;

  return (
    <SproutSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10 md:gap-14">
        <SproutCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className={cn("grid gap-x-8 gap-y-12", columns[columnCount || 3])}>
          {items.map((item, index) => (
            <article
              className={cn(
                "relative border-t-[0.7rem] px-1 pt-6",
                index % 4 === 0 && "border-coral",
                index % 4 === 1 && "border-sky",
                index % 4 === 2 && "border-sunflower",
                index % 4 === 3 && "border-leaf",
              )}
              key={index}
            >
              <span className="absolute -top-[0.7rem] right-0 h-[0.7rem] w-5 bg-navy-ink" />
              <p className="font-sprout-display text-6xl font-bold leading-none tracking-[-0.035em] text-foreground md:text-7xl">
                {item.value}
              </p>
              <h3 className="mt-5 font-sprout-mono text-base font-extrabold text-foreground">
                {item.label}
              </h3>
              {item.description ? (
                <SproutRichText
                  className="mt-3 max-w-[32ch] text-base text-basalt md:text-lg"
                  content={item.description}
                />
              ) : null}
            </article>
          ))}
        </div>
      </div>
    </SproutSection>
  );
};

StatsBlock.displayName = "Block::StatsBlock";
